import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Restaurar ruta tras 404.html → index.html (hosts sin mod_rewrite)
const spaRedirect = sessionStorage.getItem('chefmargaro_spa_redirect');
if (spaRedirect) {
  sessionStorage.removeItem('chefmargaro_spa_redirect');
  window.history.replaceState(null, '', spaRedirect);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
